import { deriveBackendOrigin } from './derive-origin';

/**
 * TODO(prod-api): PRIVREMENO — obrisati kad produkcioni backend (emeni.rs) pređe na novi API
 * (BackOffice `test`/`dev` linija, commit 8f335f7: `table/charge` bez stola → naplata po porudžbini).
 * Spisak svega što se tada briše: BackOffice `docs/prod-api-cleanup.md`.
 *
 * Da li backend na koji ide naplata ima objedinjenu naplatu (`table/charge` sa tableID=0).
 * Produkcioni backend je nema: `table/charge` bez stola tamo traži sto sa ID 0 i puca, pa se
 * samostalna porudžbina naplaćuje starim `table/chargeSingleOrder`. Stari endpoint postoji i na
 * novom backendu, pa je on podrazumevan svuda osim na test serveru (test.emeni.rs i poddomeni,
 * npr. app.test.emeni.rs / app-s01.test.emeni.rs), gde se testira nova naplata.
 *
 * Gleda se backend na koji zahtev stvarno ide — uključujući WS server-switch override.
 */
export function useUnifiedCharge(): boolean {
  const host = deriveBackendOrigin().host.split(':')[0].toLowerCase();
  return host === 'test.emeni.rs' || host.endsWith('.test.emeni.rs');
}
